import React from 'react';
import PropTypes from 'prop-types';

import { Chip, IconClose } from '@klarna/bubble-ui';

const style = {
  display: 'inline-block',
  margin: '10px 5px 0 0',
};

type ValueItemProps = {
  itemKey: string;
  label: string;
  onClick: (e: any) => void;
};

export const ValueItem = ({
  itemKey,
  label,
  onClick = () => {},
  ...rest
}: ValueItemProps): JSX.Element => (
  <div style={style} key={itemKey}>
    <Chip title={label} isActive leftIcon={IconClose} onPress={onClick} {...rest} />
  </div>
);

ValueItem.propTypes = {
  itemKey: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
